import BannerOperation from "./BannerOperation";
import LoadingOperation from "./LoadingOperation";
import SizeOperation from "./SizeOperation";
import useOperationInteractions, { IPropsWrapperOp } from "./useOperationInteractions";

export default function WrapperOperation(props: IPropsWrapperOp) {
    const common = useOperationInteractions(props);

    return (
        <SizeOperation operationType={props.operationType} event={common} data={props.data}>
            <BannerOperation />
            <LoadingOperation />
            {props.children}
        </SizeOperation>
    );
}
